import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 9l4 -4l4 4","key":"svg-0"}],["path",{"d":"M16 15l-4 4l-4 -4","key":"svg-1"}]]

const IconSelector = createReactComponent('outline', 'selector', 'Selector', __iconNode);

export default IconSelector;